import {useRef, useState} from 'react';
import {Box} from '@mui/material';
import ArrButton from '../common/arr-button/ArrButton';
import {t} from 'i18next';
import ManageHeader from '../components/manage-header/ManageHeader';
import {ISelectItem} from '../../shared/types';
import './KeywordHighlightList.scss';
import KeywordHighlightListGrid, {
  KeywordHighlightListGridRef,
} from './Keyword-Highlight-Grid/KeywordHighlightListGrid';
import {
  AddEditKeywordHighlightModal,
  AddEditKeywordHightlightdModalRef,
} from '../KeywordHighlighting/add-edit-keyword-highlight/AddEditKeywordModal';

const KeywordHighlightList = () => {
  const [selectedGroup, setSelectedGroup] = useState<ISelectItem | null>(null);
  const addEditKeywordGrpRef = useRef<AddEditKeywordHightlightdModalRef>(null);
  const gridRef = useRef<KeywordHighlightListGridRef>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const addProjectGrpModal = () => {
    if (addEditKeywordGrpRef.current) {
      addEditKeywordGrpRef.current.open();
    }
  };

  const handleRefreshList = () => {
    gridRef.current?.refreshList();
      setTimeout(() => {  
        buttonRef.current?.focus();
      },0)
  };

  return (
    <Box className="keywordHighlight-view">
      <Box className="keywordHighlight-header">
        <ManageHeader
          title={t('keywordHighlighting.title')}
          infoContentTitle={t('keywordHighlighting.headerTooltip.title')}
          infoContent={t('keywordHighlighting.headerTooltip.content')}
          onChangeGroup={setSelectedGroup}
        />
      </Box>
      <Box display="flex" justifyContent="flex-end" pt={4} pb={2}>
        <ArrButton
          aria-label={t('keywordHighlighting.btnText')}
          type="submit"
          ref={buttonRef}
          variant="primary"
          dataTestId={'keywordHighlighting.btnText'}
          title={t('keywordHighlighting.btnText')}
          size="small"
          onClick={addProjectGrpModal}
        >
          {t('keywordHighlighting.btnText')}
        </ArrButton>
      </Box>
      <AddEditKeywordHighlightModal
        ref={addEditKeywordGrpRef}
        onSaveSuccess={handleRefreshList}
        setShowModal={setShowEditModal}     
        showModal={showEditModal}
      />
      <KeywordHighlightListGrid selectedGroup={selectedGroup} ref={gridRef} />
    </Box>
  );
};

export default KeywordHighlightList;
